module.exports = __webpack_public_path__ + "img/kitchen-display.1511a6c9.png";